module.exports = __webpack_public_path__ + "img/corriente_c.79380e24.svg";